import React from 'react'
import { ResponsiveBar } from '@nivo/bar'

export const CarBarCharParesa = ({ title, info, type, usersEnd = 1 }) => {
    const data = [];
    Object.keys(info).forEach(key => {
        data.push({
            name:key,
            tiempo: Math.round((info[key].time/info[key].intents)/60),
            errores: (info[key].fails/info[key].intents)
        })
    })
    return (
        <div className="w-[376px] h-[432px] bg-white rounded-2xl shadow-sm p-4 text-center">
            <p className="text-black font-semibold text-sm">{title}</p>
            <ResponsiveBar
                data={data}
                keys={type === "unique" ? ["errores"] : ["tiempo"]}
                indexBy="name"
                margin={{ top: 5, right: 10, bottom: 50, left: 60 }}

                padding={0.4}
                groupMode="grouped"
                layout="horizontal"
                valueScale={{ type: 'linear' }}
                indexScale={{ type: 'band', round: true }}
                colors={type === "unique" ? ['#3366FF'] : ['#8055AE', '#8055AE']}
                borderColor="black"

                axisTop={null}
                axisRight={null}
                axisLeft={{
                    tickValues: 10,
                }}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legendPosition: 'start',
                    legend: type === "unique" ? "Errores" : "Tiempo (min)",
                    legendOffset: 32,

                    truncateTickAt: 0
                }}
                enableLabel={false}
                labelSkipWidth={12}
                labelSkipHeight={12}
                labelTextColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            1.6
                        ]
                    ]
                }}

                role="application"
                ariaLabel="Nivo bar chart demo"
                barAriaLabel={e => e.id + ": " + e.formattedValue + " in name: " + e.indexValue}
            />
        </div>
    )
}
